var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSize23 = function SvgIconSize23(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 22,
    x: 3.5,
    y: 1,
    stroke: "#777E90",
    rx: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F9FD",
    d: "M.5 6h19v12H.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    d: "M1.912 16.5v-1.44q0-.528.144-.9.156-.372.528-.672.372-.312 1.008-.6l1.644-.756q.6-.276.948-.708.348-.444.348-1.14 0-.84-.468-1.308t-1.32-.468q-.84 0-1.32.468t-.48 1.308H1.816q0-.756.312-1.392.324-.636.972-1.008.648-.384 1.644-.384t1.632.384q.648.372.96.984.324.612.324 1.332v.168q0 .948-.552 1.596-.54.648-1.464 1.068L4 13.788q-.552.252-.744.504t-.192.672v1.104l-.312-.552h5.016v.984zm7.382 0v-1.464h1.392V16.5zm0-4.44v-1.464h1.392v1.464zm5.853 4.656q-.984 0-1.668-.384a2.67 2.67 0 0 1-1.044-1.02 2.8 2.8 0 0 1-.348-1.38h1.128q0 .816.516 1.296.528.48 1.416.48.588 0 1.02-.216t.672-.612q.24-.408.24-.948 0-.816-.528-1.32-.516-.504-1.392-.504-.372 0-.648.096a2 2 0 0 0-.468.216l-.576-1.032 3.348-2.448-.12-.216h-4.26V7.74h5.34v1.596l-2.772 2.016-.84.036a3 3 0 0 1 .444-.12q.252-.048.588-.048.96 0 1.632.36t1.02.96q.36.6.36 1.308v.168q0 .696-.36 1.32-.348.612-1.032.996-.672.384-1.668.384"
  })));
};
export default SvgIconSize23;